import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import styled from '@emotion/styled';

import { getColor } from '../common/UICommon';
import { BaseStep, StepProps, TitleAndDescriptionProps, StepWizardProps } from '../common/BaseStep';

import onboardingListIconChecked from '../../assets/onboardingListIconChecked.svg';
import onboardingListIcon from '../../assets/onboardingListIcon.svg';

const RootBox = styled(Box)`
  padding: 8px 32px 0 32px;
`;

const ProgressBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  color: ${getColor('BLACK_80')};
`;

const P = styled.p`
  &.checked {
    font-weight: 600;
    color: ${getColor('SYSTEM_GREEN')};
  }
`;

interface OnboardingProcessStatusProps extends TitleAndDescriptionProps, StepProps, StepWizardProps {
  onboardingSteps: string[];
  currentStepIndex: number;
}

export const ProgressStatusStep = (props: OnboardingProcessStatusProps) => {
  const { onboardingSteps, currentStepIndex, isActive } = props;

  useEffect(() => {
    if (isActive) return window.scrollTo(0, 0);
  }, [isActive]);

  return (
    <>
      {isActive ? (
        <BaseStep {...props}>
          <RootBox>
            {onboardingSteps.map((step, index) => {
              return (
                <ProgressBox key={step}>
                  <img src={index <= currentStepIndex ? onboardingListIconChecked : onboardingListIcon} alt="point" />
                  <P className={index <= currentStepIndex ? 'checked' : ''}>{step}</P>
                </ProgressBox>
              );
            })}
          </RootBox>
        </BaseStep>
      ) : (
        ''
      )}
    </>
  );
};
